import {useEffect, useState} from "react";
import ResultListBox from "../ResultListBox";
import WinFormInput from "../WinFormInput";
import WinFormSelectValue from "../WinFormSelectValue";
import {Typography} from "antd";
import ResultHeaderCell from "../../../../components/table/ResultHeaderCell";
import ResultBodyCell from "../../../../components/table/ResultBodyCell";
import UIComponentHelper from "../UIComponentHelper";

export default function CulvertEditor({windowName, data, title, targetWindow, selectedCulvert, onChangeCulvert}) {
    const [barrel, setBarrel] = useState({xy: []})
    const getCulvertData = ({culvert}) => {
        return data.find(x => x.culvert_name === culvert)
    }

    useEffect(() => {
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'sol_criteria'})
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'shape'})
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'span'})
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'rise'})
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'chart'})
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'scale'})
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'dist_upstrm_xs'})
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'culvert_length'})
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'depth_bottom_n'})
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'entrance_loss_coeff'})
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'depth_blocked'})
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'exit_loss_coeff'})
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'upstrm_elev'})
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'mann_top'})
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'downstrm_elev'})
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'mann_bottom'})
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'mann_bottom'})
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'barrels_count'})
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'barrel_length'})
        UIComponentHelper.setStyleForTable({targetWindow, windowName, name: 'barrel_table', skipIndex: [0]})
        UIComponentHelper.setStyleForTable({targetWindow, windowName, name: 'barrel_xy_table', skipIndex: [0]})
    }, [selectedCulvert, barrel, data]);

    const getFilledData = ({data, size}) => {
        const xy = data || []
        for(let i=xy.length; i<size; i++) {
            xy.push([])
        }

        return xy;
    }

    useEffect(() => {
        const barrels = getFilledData({data: getCulvertData({culvert: selectedCulvert})?.barrels, size: 9})
        if(barrels?.length > 0) {
            setBarrel(barrels[0])
        }
    }, [data, selectedCulvert]);

    return (
        <div style={{border: '1px solid #cfcfcf'}}>
            <Typography.Text style={{fontSize: '11pt', fontWeight: 'bold', backgroundColor: 'white', width: '100%', marginLeft: 4}}>
                Culvert Data Editor - {title}
            </Typography.Text>
            <div style={{width: 550, backgroundColor: '#f5f5f5', fontSize: '9pt', padding: 4, paddingLeft: 4, paddingRight: 4}} id={windowName}>
                <div style={{display: 'flex', marginBottom: 2}}>
                    <div style={{width: 120}}>Culvert Group:</div>
                    <div>
                        <ResultListBox
                            width={150}
                            text={' '}
                            value={selectedCulvert}
                            list={data?.map(x => x.culvert_name)}
                            onChange={(val) => onChangeCulvert && onChangeCulvert(val)}
                        />
                    </div>
                </div>
                <div style={{display: 'flex', marginBottom: 2}}>
                    <div style={{width: 120}}>Solution Creteria:</div>
                    <div>
                        <WinFormSelectValue id={`${windowName}-sol_criteria`} style={{width: 150}}>
                            {getCulvertData({culvert: selectedCulvert})?.sol_criteria_name}
                        </WinFormSelectValue>
                    </div>
                </div>
                <div style={{display: 'flex', marginBottom: 2}}>
                    <div style={{width: 120}}>Shape:</div>
                    <div>
                        <WinFormSelectValue id={`${windowName}-shape`} style={{width: 150}}>
                            {`${getCulvertData({culvert: selectedCulvert})?.shape_name}`}
                        </WinFormSelectValue>
                    </div>
                    <div style={{width: 32, marginLeft: 8}}>Span:</div>
                    <div>
                        <WinFormInput id={`${windowName}-span`} style={{width: 60}}>
                            {getCulvertData({culvert: selectedCulvert})?.span}
                        </WinFormInput>
                    </div>
                    <div style={{width: 32, marginLeft: 8}}>Rise:</div>
                    <div>
                        <WinFormInput id={`${windowName}-rise`} style={{width: 60}}>
                            {getCulvertData({culvert: selectedCulvert})?.rise}
                        </WinFormInput>
                    </div>
                </div>
                <br/>
                <div>
                    <div style={{display: 'flex', marginBottom: 2}}>
                        <div style={{width: 60}}>Chart #:</div>
                        <div>
                            <WinFormSelectValue id={`${windowName}-chart`} style={{width: 410}}>
                                {`${getCulvertData({culvert: selectedCulvert})?.chart} - ${getCulvertData({culvert: selectedCulvert})?.chart_name}`}
                            </WinFormSelectValue>
                        </div>
                    </div>
                    <div style={{display: 'flex', marginBottom: 2}}>
                        <div style={{width: 60}}>Scale #:</div>
                        <div>
                            <WinFormSelectValue id={`${windowName}-scale`} style={{width: 410}}>
                                {`${getCulvertData({culvert: selectedCulvert})?.scale} - ${getCulvertData({culvert: selectedCulvert})?.scale_name}`}
                            </WinFormSelectValue>
                        </div>
                    </div>
                </div>
                <div>
                    <div style={{display: 'flex', marginBottom: 2}}>
                        <div style={{width: 150}}>Distance to Upstrm XS:</div>
                        <div style={{width: 100}}>
                            <WinFormInput id={`${windowName}-dist_upstrm_xs`} style={{width: '100%'}}>
                                {getCulvertData({culvert: selectedCulvert})?.dist_upstrm_xs}
                            </WinFormInput>
                        </div>
                    </div>
                    <div style={{display: 'flex', marginBottom: 2}}>
                        <div style={{width: 150}}>Culvert Length:</div>
                        <div style={{width: 100, marginRight: 40}}>
                            <WinFormInput id={`${windowName}-culvert_length`} style={{width: '100%'}}>
                                {getCulvertData({culvert: selectedCulvert})?.culvert_length}
                            </WinFormInput>
                        </div>
                        <div style={{width: 150}}>Depth to use Bottom n:</div>
                        <div style={{width: 100}}>
                            <WinFormInput id={`${windowName}-depth_bottom_n`} style={{width: '100%'}}>
                                {getCulvertData({culvert: selectedCulvert})?.depth_bottom_n}
                            </WinFormInput>
                        </div>
                    </div>
                    <div style={{display: 'flex', marginBottom: 2}}>
                        <div style={{width: 150}}>Entrance Loss Coeff:</div>
                        <div style={{width: 100, marginRight: 40}}>
                            <WinFormInput id={`${windowName}-entrance_loss_coeff`} style={{width: '100%'}}>
                                {getCulvertData({culvert: selectedCulvert})?.entrance_loss_coeff}
                            </WinFormInput>
                        </div>
                        <div style={{width: 150}}>Depth Blocked:</div>
                        <div style={{width: 100}}>
                            <WinFormInput id={`${windowName}-depth_blocked`} style={{width: '100%'}}>
                                {getCulvertData({culvert: selectedCulvert})?.depth_blocked}
                            </WinFormInput>
                        </div>
                    </div>
                    <div style={{display: 'flex', marginBottom: 2}}>
                        <div style={{width: 150}}>Exit Loss Coeff:</div>
                        <div style={{width: 100, marginRight: 40}}>
                            <WinFormInput id={`${windowName}-exit_loss_coeff`} style={{width: '100%'}}>
                                {getCulvertData({culvert: selectedCulvert})?.exit_loss_coeff}
                            </WinFormInput>
                        </div>
                        <div style={{width: 150}}>Upstream Invert Elev:</div>
                        <div style={{width: 100}}>
                            <WinFormInput id={`${windowName}-upstrm_elev`} style={{width: '100%'}}>
                                {getCulvertData({culvert: selectedCulvert})?.upstrm_elev}
                            </WinFormInput>
                        </div>
                    </div>
                    <div style={{display: 'flex', marginBottom: 2}}>
                        <div style={{width: 150}}>Manning's n for Top:</div>
                        <div style={{width: 100, marginRight: 40}}>
                            <WinFormInput id={`${windowName}-mann_top`} style={{width: '100%'}}>
                                {getCulvertData({culvert: selectedCulvert})?.mann_top}
                            </WinFormInput>
                        </div>
                        <div></div>
                        <div style={{width: 150}}>Downstream Invert Elev:</div>
                        <div style={{width: 100}}>
                            <WinFormInput id={`${windowName}-downstrm_elev`} style={{width: '100%'}}>
                                {getCulvertData({culvert: selectedCulvert})?.downstrm_elev}
                            </WinFormInput>
                        </div>
                    </div>
                    <div style={{display: 'flex', marginBottom: 2}}>
                        <div style={{width: 150}}>Manning's n for Bottom:</div>
                        <div style={{width: 100}}>
                            <WinFormInput id={`${windowName}-mann_bottom`} style={{width: '100%'}}>
                                {getCulvertData({culvert: selectedCulvert})?.mann_top}
                            </WinFormInput>
                        </div>
                    </div>
                </div>

                <br/>
                <fieldset style={{border: '1px solid #a5a5a5', padding: 0}}>
                    <legend style={{fontSize: '9pt', marginLeft: 4, paddingLeft: 2, width: 120, marginBottom: 0}}>Culvert Barrel Data</legend>
                    <div style={{marginBottom: 4, padding: 2}}>
                        <div style={{display: 'flex'}}>
                            <fieldset style={{border: '1px solid #a5a5a500'}}>
                                <legend style={{fontSize: '9pt', paddingLeft: 2, width: 165}}></legend>
                                <div>
                                    <div style={{borderBottom: '1px solid #cfcfcf00', height: 18}}>
                                        {' '}
                                    </div>
                                    <div style={{border: '1px solid #cfcfcf00', padding: 2}}>
                                        <table>
                                            <tr>
                                                <td style={{width: 155}}>
                                                    <div style={{textAlign: 'center', backgroundColor: '#008080', color: 'white'}}>Barrel Centerline Station</div>
                                                </td>
                                                <td style={{paddingLeft: 10, width: 65}}>
                                                    # Barrels:
                                                </td>
                                                <td>
                                                    <WinFormSelectValue id={`${windowName}-barrels_count`} style={{width: 65}}>
                                                        {getCulvertData({culvert: selectedCulvert})?.barrels_count}
                                                    </WinFormSelectValue>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan={3}>
                                                    <table style={{width: '100%'}}>
                                                        <thead style={{tableLayout: 'fixed', width: '100%', display: 'block'}}>
                                                        <tr>
                                                            <ResultHeaderCell style={{width: 30}}></ResultHeaderCell>
                                                            <ResultHeaderCell style={{textAlign: 'center', width: 125,}}>Barrel Name</ResultHeaderCell>
                                                            <ResultHeaderCell style={{textAlign: 'center', width: 65,}}>US Sta</ResultHeaderCell>
                                                            <ResultHeaderCell style={{textAlign: 'center', width: 65,}}>DS Sta</ResultHeaderCell>
                                                        </tr>
                                                        </thead>
                                                        <div style={{overflow: 'auto',height: 220, width: '100%'}}>
                                                            <tbody id={`${windowName}-barrel_table`} style={{tableLayout: 'fixed', width: '100%', display: 'block'}}>
                                                            {

                                                                getFilledData({data: getCulvertData({culvert: selectedCulvert})?.barrels, size: 9})?.map((x,idx) => (
                                                                    <tr>
                                                                        <ResultHeaderCell style={{width: 30}}>{idx+1}</ResultHeaderCell>
                                                                        <ResultBodyCell
                                                                            style={{backgroundColor: 'white', width: 125,}}
                                                                            onClick={() => {setBarrel(x)}}
                                                                        >
                                                                            {x.barrel_name}
                                                                        </ResultBodyCell>
                                                                        <ResultBodyCell
                                                                            onClick={() => {setBarrel(x)}}
                                                                            style={{backgroundColor: 'white', width: 65,}}
                                                                        >
                                                                            {x.us}
                                                                        </ResultBodyCell>
                                                                        <ResultBodyCell
                                                                            onClick={() => {setBarrel(x)}}
                                                                            style={{backgroundColor: 'white', width: 65,}}
                                                                        >
                                                                            {x.ds}
                                                                        </ResultBodyCell>
                                                                    </tr>
                                                                ))
                                                            }
                                                            </tbody>
                                                        </div>
                                                    </table>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </fieldset>
                            <div style={{marginLeft: 16}}>
                                <fieldset style={{border: '1px solid #a5a5a5'}}>
                                    <legend style={{fontSize: '9pt', marginLeft: 4, paddingLeft: 2, width: 165}}>Barrel GIS Data: {barrel?.barrel_name}</legend>
                                    <div style={{padding: 2}}>
                                        <table style={{width: '100%'}}>
                                            <tr>
                                                <td style={{width: 200}}>
                                                    Length: <span id={`${windowName}-barrel_length`}>{barrel?.length?.toFixed(2)}</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan={3}>
                                                    <table style={{width: '100%'}}>
                                                        <thead style={{tableLayout: 'fixed', width: '100%', display: 'block'}}>
                                                        <tr>
                                                            <ResultHeaderCell style={{width: 30}}></ResultHeaderCell>
                                                            <ResultHeaderCell style={{textAlign: 'center', width: 80,}}>X</ResultHeaderCell>
                                                            <ResultHeaderCell style={{textAlign: 'center', width: 80,}}>Y</ResultHeaderCell>
                                                        </tr>
                                                        </thead>
                                                        <div style={{overflow: 'auto', height: 220, width: '100%'}}>
                                                            <tbody id={`${windowName}-barrel_xy_table`} style={{tableLayout: 'fixed', width: '100%', display: 'block'}}>
                                                            {
                                                                getFilledData({data: barrel?.xy, size: 9}).map((x,idx) => (
                                                                    <tr>
                                                                        <ResultHeaderCell style={{width: 30}}>{idx+1}</ResultHeaderCell>
                                                                        <ResultBodyCell style={{backgroundColor: 'white', width: 80,}}>{x[0]}</ResultBodyCell>
                                                                        <ResultBodyCell style={{backgroundColor: 'white', width: 80,}}>{x[1]}</ResultBodyCell>
                                                                    </tr>
                                                                ))
                                                            }
                                                            </tbody>
                                                        </div>
                                                    </table>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
    )
}